import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 px-10 mx-5 mt-10 font-inter gap-12" }
const _hoisted_2 = { class: "col-span-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "text-2xl font-medium" }, "Social", -1)
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_691_1942)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.899 0.277345H8.933C5.601 0.277345 3.448 2.48634 3.448 5.90534V8.50034H0.466001C0.40472 8.50034 0.344043 8.51243 0.28744 8.53591C0.230837 8.55939 0.179421 8.59381 0.136136 8.63719C0.092851 8.68056 0.0585457 8.73205 0.0351859 8.78871C0.0118261 8.84536 -0.00013043 8.90606 1.07305e-06 8.96734V12.7273C1.07305e-06 12.8509 0.0490971 12.9695 0.136489 13.0569C0.223881 13.1442 0.34241 13.1933 0.466001 13.1933H3.448V22.6773C3.448 22.7385 3.46006 22.7991 3.48347 22.8557C3.50689 22.9122 3.54122 22.9636 3.58449 23.0069C3.62776 23.0501 3.67913 23.0845 3.73567 23.1079C3.79221 23.1313 3.8528 23.1433 3.914 23.1433H7.804C7.92759 23.1433 8.04612 23.0942 8.13351 23.0069C8.22091 22.9195 8.27 22.8009 8.27 22.6773V13.1933H11.756C11.8796 13.1933 11.9981 13.1442 12.0855 13.0569C12.1729 12.9695 12.222 12.8509 12.222 12.7273V8.96734C12.222 8.84349 12.1728 8.72471 12.0852 8.63713C11.9976 8.54955 11.8789 8.50034 11.755 8.50034H8.271V6.30034C8.271 5.24334 8.523 4.70634 9.9 4.70634H11.9C12.0236 4.70634 12.1421 4.65725 12.2295 4.56986C12.3169 4.48246 12.366 4.36394 12.366 4.24035V0.748345C12.3667 0.686645 12.3551 0.625428 12.3319 0.568246C12.3087 0.511065 12.2744 0.459057 12.2309 0.41524C12.1875 0.371424 12.1358 0.336671 12.0788 0.313C12.0218 0.289328 11.9607 0.277209 11.899 0.277345Z" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_691_1942" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12.364",
      height: "22.869",
      fill: "white",
      transform: "translate(0 0.277344)"
    })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["fill"]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_691_1947)\"><path d=\"M16.19 0.277344H2.779C2.04221 0.278138 1.33582 0.57118 0.814827 1.09217C0.293836 1.61316 0.000794101 2.31955 0 3.05634L0 16.4673C0.000794101 17.2041 0.293836 17.9105 0.814827 18.4315C1.33582 18.9525 2.04221 19.2456 2.779 19.2463H16.19C16.9268 19.2456 17.6332 18.9525 18.1542 18.4315C18.6752 17.9105 18.9682 17.2041 18.969 16.4673V3.05634C18.9682 2.31955 18.6752 1.61316 18.1542 1.09217C17.6332 0.57118 16.9268 0.278138 16.19 0.277344V0.277344ZM9.521 14.7253C8.53209 14.7253 7.56539 14.4321 6.74315 13.8827C5.9209 13.3333 5.28004 12.5524 4.9016 11.6388C4.52316 10.7251 4.42415 9.7198 4.61707 8.74989C4.81 7.77999 5.2862 6.88907 5.98547 6.18981C6.68473 5.49055 7.57564 5.01434 8.54555 4.82142C9.51545 4.62849 10.5208 4.72751 11.4344 5.10595C12.348 5.48438 13.1289 6.12525 13.6783 6.94749C14.2278 7.76974 14.521 8.73644 14.521 9.72534C14.5191 11.0509 13.9918 12.3216 13.0545 13.2588C12.1172 14.1961 10.8465 14.7235 9.521 14.7253ZM15.078 5.83434C14.7483 5.83434 14.426 5.73658 14.1519 5.5534C13.8777 5.37023 13.6641 5.10988 13.5379 4.80528C13.4117 4.50067 13.3787 4.16549 13.443 3.84213C13.5074 3.51876 13.6661 3.22173 13.8993 2.9886C14.1324 2.75546 14.4294 2.5967 14.7528 2.53237C15.0762 2.46805 15.4113 2.50107 15.7159 2.62724C16.0205 2.75341 16.2809 2.96707 16.4641 3.24121C16.6472 3.51534 16.745 3.83764 16.745 4.16734C16.7445 4.6093 16.5687 5.033 16.2562 5.34551C15.9437 5.65801 15.52 5.83381 15.078 5.83434Z\"></path><path d=\"M15.0794 3.61133C14.9695 3.61133 14.862 3.64394 14.7705 3.70503C14.6791 3.76613 14.6078 3.85296 14.5658 3.95456C14.5237 4.05616 14.5127 4.16794 14.5341 4.27579C14.5556 4.38365 14.6085 4.48272 14.6863 4.56048C14.764 4.63824 14.8631 4.69119 14.971 4.71265C15.0788 4.7341 15.1906 4.72309 15.2922 4.68101C15.3938 4.63893 15.4807 4.56766 15.5417 4.47623C15.6028 4.38479 15.6354 4.27729 15.6354 4.16733C15.6354 4.01987 15.5769 3.87845 15.4726 3.77418C15.3683 3.66991 15.2269 3.61133 15.0794 3.61133Z\"></path><path d=\"M9.52281 5.83398C8.75344 5.83398 8.00135 6.06212 7.36164 6.48956C6.72194 6.917 6.22334 7.52455 5.92892 8.23535C5.63449 8.94616 5.55746 9.72829 5.70756 10.4829C5.85766 11.2375 6.22814 11.9306 6.77217 12.4746C7.31619 13.0187 8.00933 13.3891 8.76391 13.5392C9.5185 13.6893 10.3006 13.6123 11.0114 13.3179C11.7222 13.0234 12.3298 12.5249 12.7572 11.8851C13.1847 11.2454 13.4128 10.4934 13.4128 9.72398C13.4115 8.6927 13.0012 7.70404 12.272 6.97481C11.5428 6.24558 10.5541 5.83531 9.52281 5.83398Z\"></path></g><defs><clipPath id=\"clip0_691_1947\"><rect width=\"18.968\" height=\"18.968\" fill=\"white\" transform=\"translate(0 0.277344)\"></rect></clipPath></defs>", 2)
const _hoisted_18 = [
  _hoisted_16
]
const _hoisted_19 = { class: "col-span-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { class: "text-2xl font-medium" }, "Contato", -1)
const _hoisted_21 = { class: "" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", { class: "text-2xl font-medium" }, "Sobre nós", -1)
const _hoisted_23 = { class: "mx-auto" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "text-2xl font-medium" }, "Segurança", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/assets/footer/google_safe_site.png" })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

import { restaurant } from '@/global/state/GlobalState';



export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  props: {
    designCustom: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    class: "py-10 hidden lg:block",
    style: _normalizeStyle({ backgroundColor: _ctx.designCustom.footerBackgroundColor ? _ctx.designCustom.footerBackgroundColor : '#f8fafb'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "mx-auto",
          style: _normalizeStyle({ color: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'})
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "hover:scale-110 transform transition duration-200",
              href: _unref(restaurant).restaurantConfig?.facebook
            }, [
              (_openBlock(), _createElementBlock("svg", {
                width: "13",
                height: "24",
                viewBox: "0 0 13 24",
                fill: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black',
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_9, 8, _hoisted_6))
            ], 8, _hoisted_5),
            _createElementVNode("a", {
              class: "hover:scale-110 transform transition duration-200",
              href: _unref(restaurant).restaurantConfig?.twitter
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                _createElementVNode("path", {
                  d: "M5.45993 2H4.0499C3.1199 2 2.64991 3.13 3.30991 3.79L9.03989 9.52C10.6799 11.16 13.3299 11.16 14.9699 9.52L20.6999 3.79C21.3599 3.13 20.8899 2 19.9599 2H18.5499C17.7199 2 16.9199 2.33 16.3299 2.92L12.7499 6.5C12.3399 6.91 11.6799 6.91 11.2699 6.5L7.68991 2.92C7.08991 2.33 6.28993 2 5.45993 2Z",
                  fill: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'
                }, null, 8, _hoisted_12),
                _createElementVNode("path", {
                  d: "M5.45993 21.97H4.0499C3.1199 21.97 2.64991 20.84 3.30991 20.18L9.03989 14.45C10.6799 12.81 13.3299 12.81 14.9699 14.45L20.6999 20.18C21.3599 20.84 20.8899 21.97 19.9599 21.97H18.5499C17.7199 21.97 16.9199 21.64 16.3299 21.05L12.7499 17.47C12.3399 17.06 11.6799 17.06 11.2699 17.47L7.68991 21.05C7.08991 21.64 6.28993 21.97 5.45993 21.97Z",
                  fill: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'
                }, null, 8, _hoisted_13)
              ]))
            ], 8, _hoisted_10),
            _createElementVNode("a", {
              class: "hover:scale-110 transform transition duration-200",
              href: _unref(restaurant).restaurantConfig?.instagram
            }, [
              (_openBlock(), _createElementBlock("svg", {
                width: "19",
                height: "20",
                viewBox: "0 0 19 20",
                fill: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black',
                xmlns: "http://www.w3.org/2000/svg"
              }, _hoisted_18, 8, _hoisted_15))
            ], 8, _hoisted_14)
          ])
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", {
          class: "mx-auto",
          style: _normalizeStyle({ color: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'})
        }, [
          _hoisted_20,
          _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(restaurant).email), 1)
        ], 4)
      ]),
      _createElementVNode("div", {
        class: "col-span-4",
        style: _normalizeStyle({ color: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'})
      }, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(restaurant).aboutUs), 1)
        ])
      ], 4),
      _createElementVNode("div", {
        class: "col-span-4",
        style: _normalizeStyle({ color: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'})
      }, _hoisted_27, 4)
    ]),
    (_unref(restaurant).address)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          style: _normalizeStyle({ color: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'}),
          class: "text-center py-5 pt-10 font-medium"
        }, "Endereço: " + _toDisplayString(_unref(restaurant).address), 5))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      style: _normalizeStyle({ color: _ctx.designCustom.footerTextColor ? _ctx.designCustom.footerTextColor : 'black'}),
      class: "text-center font-medium"
    }, "Todos os direitos reservados ©️", 4)
  ], 4))
}
}

})